import React from 'react';
import ServiceTemplate from '../components/ServiceTemplate';

const CustomsClearance = () => {
  return (
    <ServiceTemplate
      title="Customs Clearance"
      subtitle="Clearing Agent Services"
      description="Expert customs clearance support ensuring compliance, documentation accuracy, and smooth processing for imports and exports."
      whatIsIt="Customs clearance is the process of preparing and submitting documentation to facilitate import or export of goods. A clearing agent ensures your shipment complies with customs regulations, calculates duties and taxes, and coordinates with customs authorities. NETEXEC GLOBAL provides expert clearing agent services for South African imports and exports."
      whoFor="This service is for businesses importing goods into South Africa or exporting from South Africa who need customs compliance support. It's essential for any business moving commercial cargo across international borders."
      whenToUse="Use customs clearance services for every international shipment. Customs clearance is mandatory for import and export cargo, and expert support ensures smooth processing, compliance, and avoidance of delays or penalties."
      howWeHelp="NETEXEC GLOBAL handles customs clearance on your behalf. We prepare all required documentation, ensure compliance with regulations, coordinate with customs authorities, calculate duties and taxes, and facilitate smooth processing at ports and border crossings."
      benefits={[
        'Accurate documentation and regulatory compliance',
        'Reduced risk of customs delays or penalties',
        'Expert calculation of duties, taxes, and fees',
        'Coordination with South African and international customs authorities',
        'Guidance on import/export permits and requirements'
      ]}
      nextSteps="Provide NETEXEC GLOBAL with your cargo details, commercial invoice, packing list, and any relevant permits. We'll handle customs clearance coordination and keep you informed throughout the process."
      image="https://images.pexels.com/photos/7519247/pexels-photo-7519247.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
    />
  );
};

export default CustomsClearance;